module.exports = __webpack_public_path__ + "img/03.72587a70.png";